import { ANALYTICS_TRIGGERS } from '@24i/nxg-sdk-smartott-shared/src/analytics/constants';
import { SOTT_DEFAULT_SCREENS } from '@24i/nxg-sdk-smartott/src/navigation/constants';
import { Payload, VideoStopResult } from '../types';
import { EVENTS } from '../constants';
import { mapBase } from './mapBase';

export const mapVideoStop = (
    triggerName: ANALYTICS_TRIGGERS,
    payload: Payload
): VideoStopResult | undefined => {
    const progressPct = Math.round(parseFloat(payload.payload.percentOfPlayback.toFixed(2)));
    return {
        ...mapBase(payload),
        action: EVENTS.VIDEO_STOP,
        event_trigger: triggerName,
        thing_id: payload.payload.asset?.id || '',
        progress_pct: progressPct,
        duration: payload.payload.duration,
        source_page: SOTT_DEFAULT_SCREENS.PLAYBACK,
        source_rail: payload.payload.asset.sectionLabel,
    };
};
